module.exports = __webpack_public_path__ + "img/handball.81d11fd7.svg";